import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'maskSpan'})
export class HideSpanPipe implements PipeTransform {
  transform(value: string): string {
    return "******"
  }
}
